// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"7f57a0b3","222":"c2220c42","359":"73e003fa","421":"e6f0c198","585":"e4b8132f","634":"fc0a50b1","700":"afac3dd2","701":"d8eca9fc","902":"4fa3d6e0","906":"db92216f","995":"2d45ad40"}[chunkId] + ".chunk.js";
};